export const envSettingsSection = "/third-party-integrations";

// Individual app detail URLs
export const googleAppsUrl = () => `${envSettingsSection}/google`;
export const dealerLocatorUrl = () => `${envSettingsSection}/dealer-locator`;
export const tieredPricingUrl = () => `${envSettingsSection}/tiered-pricing`;
export const shippingEstimatorUrl = () => `${envSettingsSection}/shipping-estimator`;
export const fulfillmentWindowUrl = () => `${envSettingsSection}/fulfillment-window`;
